import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["trigger", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.triggerTarget.value

    this.fieldTargets.forEach((field) => {
      const showWhenValues = field.dataset.showWhen.split(",")
      field.classList.toggle("d-none", !showWhenValues.includes(value))
    })
  }
}
